import styled from "styled-components";
import Logo from "../assets/images/logo.svg";
import Menubar from "./Menubar";
import { Link } from "react-router-dom";
import MobileMenu from "./MobileMenu";

function Header() {
  return (
    <HeaderMain>
      <HeaderWrapper className="layoutWrapper">
        <H1>
          <Link to="/"><img src={Logo} alt="" /></Link>
        </H1>
        <section className="desktopMenu"><Menubar /></section>
        <section className="mobileMenu"><MobileMenu/></section>
      </HeaderWrapper>
    </HeaderMain>
  );
}

export default Header;

const HeaderMain = styled.section`
  height: 100px;
  background: #fff;
  box-shadow: 0 0.4rem 1.3rem 0 hsla(0, 0%, 82%, 0.5);
  position: relative;
  z-index: 1;
  .desktopMenu {
    display: block;
  }
  .mobileMenu {
    display: none;
  }
  @media (max-width: 790px) {
    .desktopMenu {
      display: none;
    }
    .mobileMenu {
      display: block;
    }
  }
`;

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  align-items: center;
`;

const H1 = styled.h1`
  border: none;
  margin: 0;
  padding: 16px 0;
`;
